import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/RolePermissionReqs/RolePermissionReqs';
import { selectedSocietyStorer } from '../../../../utils/webStorer';

// ---------- Society Roles ----------

function* getSocietyRoles(action) {
  try {
    const result = yield call(req.getSocietyRolesReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_SOCIETY_ROLES_SUCCESS, payload: result });
    } else {
      yield put({ type: types.GET_SOCIETY_ROLES_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to fetch roles');
    }
  } catch (e) {
    yield put({ type: types.GET_SOCIETY_ROLES_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* getSocietyRoleDetails(action) {
  try {
    const result = yield call(req.getSocietyRoleDetailsReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_SOCIETY_ROLE_DETAILS_SUCCESS, payload: result.data });
    } else {
      yield put({ type: types.GET_SOCIETY_ROLE_DETAILS_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to fetch role details');
    }
  } catch (e) {
    yield put({ type: types.GET_SOCIETY_ROLE_DETAILS_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* createSocietyRole(action) {
  try {
    const result = yield call(req.createSocietyRoleReq, action);
    if (result.success === true) {
      toast.success(result.message || 'Role created successfully');
      yield put({ type: types.CREATE_SOCIETY_ROLE_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.CREATE_SOCIETY_ROLE_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to create role');
    }
  } catch (e) {
    yield put({ type: types.CREATE_SOCIETY_ROLE_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* updateSocietyRole(action) {
  try {
    const result = yield call(req.updateSocietyRoleReq, action);
    if (result.success === true) {
      toast.success(result.message || 'Role updated successfully');
      yield put({ type: types.UPDATE_SOCIETY_ROLE_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.UPDATE_SOCIETY_ROLE_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to update role');
    }
  } catch (e) {
    yield put({ type: types.UPDATE_SOCIETY_ROLE_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* deleteSocietyRole(action) {
  try {
    const result = yield call(req.deleteSocietyRoleReq, action);
    if (result.success === true) {
      toast.success(result.message || 'Role deleted successfully');
      yield put({ type: types.DELETE_SOCIETY_ROLE_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.();
    } else {
      yield put({ type: types.DELETE_SOCIETY_ROLE_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to delete role');
    }
  } catch (e) {
    yield put({ type: types.DELETE_SOCIETY_ROLE_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* assignRolePermissions(action) {
  try {
    const result = yield call(req.assignRolePermissionsReq, action);
    if (result.success === true) {
      toast.success(result.message || 'Permissions updated successfully');
      yield put({ type: types.ASSIGN_ROLE_PERMISSIONS_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.ASSIGN_ROLE_PERMISSIONS_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to update permissions');
    }
  } catch (e) {
    yield put({ type: types.ASSIGN_ROLE_PERMISSIONS_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* getPermissionCatalog(action) {
  try {
    const result = yield call(req.getPermissionCatalogReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_PERMISSION_CATALOG_SUCCESS, payload: result });
    } else {
      yield put({ type: types.GET_PERMISSION_CATALOG_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to fetch permission catalog');
    }
  } catch (e) {
    yield put({ type: types.GET_PERMISSION_CATALOG_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* getPermissionCatalogGrouped(action) {
  try {
    const result = yield call(req.getPermissionCatalogGroupedReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_PERMISSION_CATALOG_GROUPED_SUCCESS, payload: result });
    } else {
      yield put({ type: types.GET_PERMISSION_CATALOG_GROUPED_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to fetch permission catalog');
    }
  } catch (e) {
    yield put({ type: types.GET_PERMISSION_CATALOG_GROUPED_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

// ---------- User ↔ Society ----------

function* getMySocieties(action) {
  try {
    const result = yield call(req.getMySocietiesReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_MY_SOCIETIES_SUCCESS, payload: result });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.GET_MY_SOCIETIES_FAILURE, message: result?.message });
    }
  } catch (e) {
    yield put({ type: types.GET_MY_SOCIETIES_FAILURE, message: e?.message });
  }
}

function* getMyPermissions(action) {
  try {
    const result = yield call(req.getMyPermissionsReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_MY_PERMISSIONS_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: result?.message });
    }
  } catch (e) {
    yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: e?.message });
  }
}

function* setActiveSociety(action) {
  // Persist active society to localStorage so the app shell rehydrates on reload.
  if (action?.data) {
    yield call([selectedSocietyStorer, selectedSocietyStorer.saveSociety], action.data);
  }
}

function* clearActiveSociety() {
  yield call([selectedSocietyStorer, selectedSocietyStorer.removeSociety]);
}

function* getSocietyUsers(action) {
  try {
    const result = yield call(req.getSocietyUsersReq, action);
    if (result.success === true) {
      yield put({ type: types.GET_SOCIETY_USERS_SUCCESS, payload: result });
    } else {
      yield put({ type: types.GET_SOCIETY_USERS_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to fetch users');
    }
  } catch (e) {
    yield put({ type: types.GET_SOCIETY_USERS_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* createUserSociety(action) {
  try {
    const result = yield call(req.createUserSocietyReq, action);
    if (result.success === true) {
      toast.success(result.message || 'User assigned successfully');
      yield put({ type: types.CREATE_USER_SOCIETY_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.CREATE_USER_SOCIETY_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to assign user');
    }
  } catch (e) {
    yield put({ type: types.CREATE_USER_SOCIETY_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* updateUserSociety(action) {
  try {
    const result = yield call(req.updateUserSocietyReq, action);
    if (result.success === true) {
      toast.success(result.message || 'Assignment updated successfully');
      yield put({ type: types.UPDATE_USER_SOCIETY_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.(result.data);
    } else {
      yield put({ type: types.UPDATE_USER_SOCIETY_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to update assignment');
    }
  } catch (e) {
    yield put({ type: types.UPDATE_USER_SOCIETY_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

function* deleteUserSociety(action) {
  try {
    const result = yield call(req.deleteUserSocietyReq, action);
    if (result.success === true) {
      toast.success(result.message || 'User removed successfully');
      yield put({ type: types.DELETE_USER_SOCIETY_SUCCESS, payload: result.data });
      action?.data?.onSuccess?.();
    } else {
      yield put({ type: types.DELETE_USER_SOCIETY_FAILURE, message: result?.message });
      toast.error(result?.message || 'Failed to remove user');
    }
  } catch (e) {
    yield put({ type: types.DELETE_USER_SOCIETY_FAILURE, message: e?.message });
    toast.error(e?.message || 'Something went wrong');
  }
}

export default function* rolePermissionSaga() {
  yield takeLatest(types.GET_SOCIETY_ROLES, getSocietyRoles);
  yield takeLatest(types.GET_SOCIETY_ROLE_DETAILS, getSocietyRoleDetails);
  yield takeLatest(types.CREATE_SOCIETY_ROLE, createSocietyRole);
  yield takeLatest(types.UPDATE_SOCIETY_ROLE, updateSocietyRole);
  yield takeLatest(types.DELETE_SOCIETY_ROLE, deleteSocietyRole);
  yield takeLatest(types.ASSIGN_ROLE_PERMISSIONS, assignRolePermissions);
  yield takeLatest(types.GET_PERMISSION_CATALOG, getPermissionCatalog);
  yield takeLatest(types.GET_PERMISSION_CATALOG_GROUPED, getPermissionCatalogGrouped);

  yield takeLatest(types.GET_MY_SOCIETIES, getMySocieties);
  yield takeLatest(types.GET_MY_PERMISSIONS, getMyPermissions);
  yield takeLatest(types.SET_ACTIVE_SOCIETY, setActiveSociety);
  yield takeLatest(types.CLEAR_ACTIVE_SOCIETY, clearActiveSociety);

  yield takeLatest(types.GET_SOCIETY_USERS, getSocietyUsers);
  yield takeLatest(types.CREATE_USER_SOCIETY, createUserSociety);
  yield takeLatest(types.UPDATE_USER_SOCIETY, updateUserSociety);
  yield takeLatest(types.DELETE_USER_SOCIETY, deleteUserSociety);
}
